"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormLabel = _interopRequireDefault(require("@mui/material/FormLabel"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Form control component
 *
 * @package HOPS
 * @subpackage Components
 * @copyright Heritage Operations Processing Limited
 */const FormControl = props => {
  /**
   * Render the content.
   * 
   * @return {ReactNode}
   */
  const renderContent = () => {
    if (!props.grouped) return props.children;else return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormGroup.default, {
      row: props.row,
      children: props.children
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormLabel.default, {
      children: props.label
    }), renderContent()]
  });
};
var _default = exports.default = FormControl;